import React from "react";
import './Counters.scss';
import {CalendarTodayTwoTone, PhotoCameraTwoTone, VideocamTwoTone} from "@mui/icons-material";
import {Badge, Stack} from "@mui/material";

function Counters(props) {
	console.log(props);
	const direction = props.parentComponent === 'DayItem' ? { xs: 'row', sm: 'column', lg: 'row' } : 'row';
	return <Stack direction={direction} spacing={3}>
		{(props.item && props.item.eventsCount !== undefined) || props.parentComponent === 'EventItem' ? <>
			{props.item.eventsCount > 0 && <Badge max={9999} badgeContent={props.item.eventsCount} color="primary">
				<CalendarTodayTwoTone color="action" />
			</Badge>}
			{props.item.imagesCount > 0 && <Badge max={9999} badgeContent={props.item.imagesCount} color="primary">
				<PhotoCameraTwoTone color="action" />
			</Badge>}
			{props.item.videosCount > 0 && <Badge max={9999} badgeContent={props.item.videosCount} color="primary">
				<VideocamTwoTone color="action" />
			</Badge>}
		</> : ''}
	</Stack>;
}

export default Counters;